var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVenn = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 170 153"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 141.473 501)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 51,
  r: 51,
  transform: "translate(112.947 849)",
  fill: "#ab80e3",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 51,
  r: 51,
  transform: "translate(180.947 849)",
  fill: "#ff66c4",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.5,
  cy: 51,
  rx: 51.5,
  ry: 51,
  transform: "translate(144.947 900)",
  fill: "#6cbbed",
  opacity: 0.4
}))));
export default SvgVenn;